webpackJsonp([162898551421021],{

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(64);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(57);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Page not found - CodeBee'
	    }),
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Page not found.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You are viewing the CodeBee archive. ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' },
	        'Read our explanation'
	      ),
	      '.'
	    )
	  );
	};
	
	exports.default = NotFoundPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-8d57565fd2e5fa479403.js